import { postRequest } from "../httpMethods";


export const postTicketChat = (payload, config = {}) =>
    postRequest(`ticket-chat/send`, payload, config);

export const postSendNotificationToken = (payload) =>
    postRequest(`push-notifications/register`, payload);

export const postGenerateTrinerSalary = (payload) =>
    postRequest(`salary/generate`, payload);


export const postTrianerLeaveApply = (payload) =>
    postRequest(`trainer-leaves/apply`, payload);



export const postGenerateContent = (payload) =>
    postRequest(`generate_gradesix_math`, payload);







